export const ImageConstants = {
  POPULATE_IMAGES: "LOAD_IMAGES_FROM_WORLD",

  FETCH_WORLD_REQUEST: "FETCH_IMAGES_BY_WORLD_REQUEST",
  FETCH_WORLD_SUCCESS: "FETCH_IMAGES_BY_WORLD_SUCCESS",
  FETCH_WORLD_FAILURE: "FETCH_IMAGES_BY_WORLD_FAILURE",

  FETCH_CHRONICLE_REQUEST: "FETCH_IMAGES_BY_CHRONICLE_REQUEST",
  FETCH_CHRONICLE_SUCCESS: "FETCH_IMAGES_BY_CHRONICLE_SUCCESS",
  FETCH_CHRONICLE_FAILURE: "FETCH_IMAGES_BY_CHRONICLE_FAILURE",

  UPDATE_IMAGE_REQUEST: "UPDATE_IMAGE_REQUEST",
  UPDATE_IMAGE_SUCCESS: "UPDATE_IMAGE_SUCCESS",
  UPDATE_IMAGE_FAILURE: "UPDATE_IMAGE_FAILURE",

  UPLOAD_IMAGE_REQUEST: "UPLOAD_IMAGE_REQUEST",
  UPLOAD_IMAGE_SUCCESS: "UPLOAD_IMAGE_SUCCESS",
  UPLOAD_IMAGE_FAILURE: "UPLOAD_IMAGE_FAILURE",

  DELETE_IMAGE_REQUEST: "DELETE_IMAGE_REQUEST",
  DELETE_IMAGE_SUCCESS: "DELETE_IMAGE_SUCCESS",
  DELETE_IMAGE_FAILURE: "DELETE_IMAGE_FAILURE",

  DELETE_MULTIPLE_IMAGE_REQUEST: "DELETE_MULTIPLE_IMAGE_REQUEST",
  DELETE_MULTIPLE_IMAGE_SUCCESS: "DELETE_MULTIPLE_IMAGE_SUCCESS",
  DELETE_MULTIPLE_IMAGE_FAILURE: "DELETE_MULTIPLE_IMAGE_FAILURE",
};
